<template>
  <div v-loading="loading">
    <Form>
      <FormItem :label="l('XUQIUMINGCHENG')">{{item.name}}</FormItem>
      <Row>
        <Col span="8">
          <FormItem :label="l('SHENGQINGREN')">{{item.applyUserName}}</FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="l('SUOSHUZUZHI')">{{item.domainName}}</FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="l('GUANLIWEIDU')">{{item.dimensionNames}}</FormItem>
        </Col>
      </Row>
      <FormItem :label="l('MIAOSHU')" class="m-b">{{item.description}}</FormItem>
      <table class="plan-table">
        <tr>
          <th>{{l("PEIXUNXUQIUDUIXIANG")}}</th>
          <th>{{l("PEIXUNXUQIULEIXING")}}</th>
          <th>{{l("KECHENGLEIBIE")}}</th>
          <th>{{l("YUJIRENSHU")}}</th>
          <th>{{l("NEIRONGXUQIU")}}</th>
          <th>{{l("XIANZHUANGFENXI")}}</th>
          <th>{{l("XUDACHENGMUBIAO")}}</th>
          <th>{{l("JIANYIKAIZHANSHIJIAN")}}</th>
          <th>{{l("SHICHANG")}}</th>
          <th>{{l("JIBIE")}}</th>
          <th>{{l("BEIZHU")}}</th>
        </tr>
        <tr v-for="(i,index) in item.trainNeedsDecInfoList" :key="index">
          <td>{{i.trainObject}}</td>
          <td>{{i.trainNeedsTypeName}}</td>
          <td>{{i.courseTypeName}}</td>
          <td>{{i.estimatedNum}}</td>
          <td>{{i.content}}</td>
          <td>{{i.analysis}}</td>
          <td>{{i.target}}</td>
          <td>{{i.developTime}} - {{i.developEndTime}}</td>
          <td>{{i.duration}}</td>
          <td>{{i.levelName}}</td>
          <td>{{i.remark}}</td>
          <td>
            <span v-for="(month,index) in i.months" :key="index">{{month}}{{l("YUE")}},</span>
          </td>
          <td>{{i.teacherNames}}</td>
        </tr>
      </table>
    </Form>
  </div>
</template>

<script>
export default {
  name: "trainNeedsAudit",
  props: ["id"],
  data() {
    return {
      loading: false,
      item: {}
    };
  },
  methods: {
    _fetch(id) {
      if (id) {
        this.loading = true;
        this.http
          .request("sys/trainNeedsDeclaration/info", { id: id })
          .then(result => {
            this.item = result.item;
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  created: function() {
    this._fetch(this.id);
  }
};
</script>

<style scoped>
.ivu-form-item {
  margin-bottom: 0px;
  vertical-align: top;
  zoom: 1;
}
.plan-table {
  width: 100%;
}
.plan-table th {
  text-align: left;
  padding: 3px;
  border: 1px solid #eeeeee;
}
.plan-table td {
  text-align: left;
  height: 25px;
  line-height: 25px;
  padding: 3px;
  border: 1px solid #eeeeee;
}
</style>



// WEBPACK FOOTER //
// trainNeedsAudit.vue?33a57378